import { ShouldElementBeDisplayed } from "./ShouldElementBeDisplayed";
import { CurrentDateTimeInfo } from "./CurrentDateTimeInfo";

export class DisplayOptions{
    showForPickup:boolean;
    showForDelivery:boolean;
    showForDaysOfWeek:number[] | null;
    showForHoursOfDay:number[] | null;
    showForDaysOfMonth:number[] | null;
    showForMonths:number[] | null;
    showForYears:number[] | null;
    showForDates:string[] | null;


    /**
     * Configurations determining whether an element should be displayed for the user or not
     * 
     * @param showForPickup TRUE if this element should be shown for pickup, FALSE if its suposed to be delivery only
     * @param showForDelivery  TRUE if this element should be shown for pickup, FALSE if its suposed to be delivery only
     * @param showForDaysOfWeek  Array containing the days of the week in which this item will be shown. Sunday is 0, Monday is 1, Tuesday is 2...
     * @param showForHoursOfDay Array containing the hours of the day in which this item will be shown. Midnight is 0, 1AM is 1... 11am is 11, noon is 12, 1pm is 13....
     * @param showForDaysOfMonth Array containing the day of the month in which this item will be shown. No tricks on this one... if you want it to show on the day 2 of a month, you would use "2"
     * @param showForMonths Array containing the months in which this item will be shown. Jan is 0, Feb is 1, March is 2....
     * @param showForYears  Array containing the years in which this item will be shown. If the year is 2020, then you put 2020. Simple.
     * @param showForDates Date on which this element should be shown. Should be on the 'YYYY-MM-DD' format.
     */
    constructor(showForPickup:boolean | null, showForDelivery:boolean | null, showForDaysOfWeek:number[] | null,showForHoursOfDay:number[] | null,
        showForDaysOfMonth:number[] | null, showForMonths:number[] | null, showForYears:number[] | null, showForDates:string[] | null){
        this.showForPickup   = showForPickup   == null ? true:showForPickup;
        this.showForDelivery = showForDelivery == null ? true:showForDelivery;
        
        this.showForDaysOfWeek = showForDaysOfWeek;
        this.showForHoursOfDay = showForHoursOfDay;
        this.showForDaysOfMonth = showForDaysOfMonth;
        this.showForMonths = showForMonths;
        this.showForYears = showForYears;
        this.showForDates = showForDates;
    }

    /** Creates a cateogry object from the data pulled from AWS. Some attributes will be added later. */
    static newFromAWS(awsItem:any):DisplayOptions | null{
        if(awsItem!=null){
            return new DisplayOptions(
                awsItem.showForPickup,
                awsItem.showForDelivery,
                awsItem.showForDaysOfWeek,
                awsItem.showForHoursOfDay,
                awsItem.showForDaysOfMonth,
                awsItem.showForMonths,
                awsItem.showForYears,
                awsItem.showForDates
            );
        }else{
            return null;
        }
        
    }

    toAwsObject(){
        let awsObj:any = {
            "showForPickup":this.showForPickup,
            "showForDelivery":this.showForDelivery,
        }
        if(this.showForDaysOfWeek!=null){
            awsObj["showForDaysOfWeek"] = this.showForDaysOfWeek;
        }
        if(this.showForHoursOfDay!=null){
            awsObj["showForHoursOfDay"] = this.showForHoursOfDay;
        }
        if(this.showForDaysOfMonth!=null){
            awsObj["showForDaysOfMonth"] = this.showForDaysOfMonth;
        }
        if(this.showForMonths!=null){
            awsObj["showForMonths"] = this.showForMonths;
        }
        if(this.showForYears!=null){
            awsObj["showForYears"] = this.showForYears;
        }
        if(this.showForDates!=null){
            awsObj["showForDates"] = this.showForDates;
        }

        return awsObj;
    }

    /**
     * Determines if the element should be displayed or not RIGHT NOW!
     */
    determineDisplayConditions(displayConditions:CurrentDateTimeInfo):ShouldElementBeDisplayed{
        let showForPickup   = this.showForPickup;
        let showForDelivery = this.showForDelivery;
        
        //If showForPickup OR showForDelivery is true, conditions are valid. If both are false, 
        //we wont even bother checking the other conditions
        let conditionsAreValid = showForPickup || showForDelivery;

        if(conditionsAreValid && this.showForDaysOfWeek!=null && this.showForDaysOfWeek.length>0){
            conditionsAreValid = this.showForDaysOfWeek.includes(displayConditions.currentDayOfWeek);
        } 

        if(conditionsAreValid && this.showForHoursOfDay!=null && this.showForHoursOfDay.length>0){
            conditionsAreValid = this.showForHoursOfDay.includes(displayConditions.currentHourOfDay);
        }

        if(conditionsAreValid && this.showForDaysOfMonth!=null && this.showForDaysOfMonth.length>0){
            conditionsAreValid = this.showForDaysOfMonth.includes(displayConditions.currentDayOfMonth);
        }

        if(conditionsAreValid && this.showForMonths!=null && this.showForMonths.length>0){
            conditionsAreValid = this.showForMonths.includes(displayConditions.currentMonth);
        }

        if(conditionsAreValid && this.showForYears!=null && this.showForYears.length>0){
            conditionsAreValid = this.showForYears.includes(displayConditions.currentYear);
        }
        
        if(conditionsAreValid && this.showForDates!=null && this.showForDates.length>0){
            conditionsAreValid = this.showForDates.includes(displayConditions.currentDate);
        }

        if(!conditionsAreValid){
            showForPickup = false;
            showForDelivery = false;
        }
        

        return new ShouldElementBeDisplayed(showForPickup,showForDelivery);
    }
}